import type { RowClickHook } from "@/features/integrations/shared/renderer/hooks/types";

const rowClickHooksRegistry = new Map<string, RowClickHook>();

export function registerCampaignsRowClickHook(
  integrationName: string,
  hook: RowClickHook
): void {
  rowClickHooksRegistry.set(integrationName.toLowerCase(), hook);
}

export function getCampaignsRowClickHook(
  integrationName: string | undefined
): RowClickHook | undefined {
  if (!integrationName) return undefined;
  return rowClickHooksRegistry.get(integrationName.toLowerCase());
}
